// import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
// import { jwtDecode } from 'jwt-decode'; // Correct import
// import {
//     setAuthTokens as saveTokens,
//     clearAuthTokens as removeTokens,
//     getRefreshToken,
//     setMemoryAccessToken, // To keep access token in memory
//     getAccessToken as getMemoryAccessToken // To potentially initialize from memory
// } from '../service/tokenService'; // Assuming tokenService.js exists in the same directory or adjust path

// // Removed API_BASE_URL import as API calls are now primarily in authService/LoginPage

// const AuthContext = createContext(null);

// export const useAuth = () => useContext(AuthContext);

// export const AuthProvider = ({ children }) => {
//     // State to hold auth information
//     const [authState, setAuthState] = useState({
//         accessToken: null, // Store access token in state (memory)
//         refreshToken: getRefreshToken(), // Initialize refresh token from localStorage
//         isAuthenticated: false, // Start as not authenticated
//         user: null, // Decoded user info from JWT
//         isLoading: true, // Start in loading state for initial check
//     });

//     // Function called by LoginPage AFTER successful login AND OTP (if required)
//     const finalizeLogin = useCallback((accessToken, refreshToken, userData) => {
//         try {
//             // Decode token to get user info and potentially expiry
//             // Ensure your backend puts necessary info (like role, name, id) into the JWT payload
//             const decodedUser = jwtDecode(accessToken);


//             saveTokens(accessToken, refreshToken); // Saves refresh token to localStorage
//             setMemoryAccessToken(accessToken);    // Save access token to memory via tokenService

//             setAuthState({
//                 accessToken: accessToken,
//                 refreshToken: refreshToken,
//                 isAuthenticated: true,
//                 user: { ...userData, ...decodedUser }, // Combine UserDto with decoded info if needed, or just use decoded info
//                 isLoading: false,
//             });
//         } catch (error) {
//             console.error("Error finalizing login (decoding token or setting state):", error);
//             // If decoding fails or state update fails, reset to logged out state
//             logout();
//         }
//     }, []); // useCallback ensures function identity remains stable

//     // Logout function
//     const logout = useCallback(() => {
//         removeTokens(); // Clears localStorage and memory token
//         setAuthState({
//             accessToken: null,
//             refreshToken: null,
//             isAuthenticated: false,
//             user: null,
//             isLoading: false, // Finished loading (into logged-out state)
//         });
//         // Optional: Add navigation to login page here or handle in components
//         // navigate('/login'); // Would need useNavigate hook if context is router-aware
//     }, []); // useCallback ensures function identity remains stable


//     // --- Initial Load / Persistence Check ---
//     // Attempt to initialize state from stored tokens on component mount
//     useEffect(() => {
//         const initializeAuth = () => {
//             const storedRefreshToken = getRefreshToken();
//             // Simple check: If refresh token exists, assume user *might* be logged in.
//             // A robust implementation would try a silent refresh here using the refresh token.
//             // For now, we just initialize refreshToken state. User still needs to login normally
//             // or the app needs a silent refresh mechanism.
//             // If you stored the access token too (e.g. sessionStorage), check it here.

//             // For now, just set loading to false. The protected routes will
//             // handle redirection if isAuthenticated remains false.
//             setAuthState(prev => ({
//                 ...prev,
//                 refreshToken: storedRefreshToken,
//                 // You could attempt a silent refresh here to set isAuthenticated, accessToken, user
//                 isLoading: false
//             }));
//         };
//         initializeAuth();
//     }, []); // Run only once on mount


//     // --- Refresh Token Handling (For interceptor/authFetch) ---
//     // Function for your fetch wrapper to call after successfully refreshing tokens
//     const setRefreshedTokens = useCallback((newAccessToken, newRefreshToken) => {
//         try {
//             const decodedUser = jwtDecode(newAccessToken);
//             saveTokens(newAccessToken, newRefreshToken); // Saves new refresh token to localStorage
//             setMemoryAccessToken(newAccessToken);    // Update memory token

//             setAuthState(prev => ({
//                 ...prev,
//                 accessToken: newAccessToken,
//                 refreshToken: newRefreshToken,
//                 isAuthenticated: true, // Definitely authenticated now
//                 user: decodedUser // Update user info from new token
//             }));
//         } catch (error) {
//             console.error("Error setting refreshed tokens:", error);
//             logout(); // If refresh fails, log out
//         }
//     }, [logout]); // Dependency on logout


//     const setUser = useCallback((user) => {
//         setAuthState(prev => ({
//             ...prev,
//             user: { ...prev.user, ...user } // Update user info in state
//         }));
//     }, []); // Function to update user info in state



//     // Value provided to consuming components
//     const value = {
//         // State
//         isAuthenticated: authState.isAuthenticated,
//         user: authState.user, // The decoded user info object
//         accessToken: authState.accessToken, // Expose access token if needed directly
//         isLoading: authState.isLoading,

//         // Actions
//         finalizeLogin, // Use this after login + OTP success
//         setUser, // Function to update user info in state
//         logout,
//         setRefreshedTokens // Function for fetch wrapper / interceptor
//     };

//     return (
//         <AuthContext.Provider value={value}>
//             {children}
//         </AuthContext.Provider>
//     );
// };


import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { jwtDecode } from 'jwt-decode'; // Correct import
import {
    setAuthTokens as saveTokens,
    clearAuthTokens as removeTokens,
    getRefreshToken,
    setMemoryAccessToken, // To keep access token in memory
    // getAccessToken as getMemoryAccessToken, // To potentially initialize from memory
    refreshToken as callRefreshTokenApi // <<< IMPORT THE REFRESH API CALL FUNCTION
} from '../service/tokenService'; // Assuming tokenService.js exists and exports refreshToken
import { CircularProgress } from '@mui/material';

// Removed API_BASE_URL import as API calls are now primarily in authService/LoginPage

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    // State to hold auth information
    const [authState, setAuthState] = useState({
        accessToken: null, // Store access token in state (memory)
        refreshToken: getRefreshToken(), // Initialize refresh token from localStorage
        isAuthenticated: false, // Start as not authenticated
        user: null, // Decoded user info from JWT
        isLoading: true, // Start in loading state for initial check: true
    });

    // Function called by LoginPage AFTER successful login AND OTP (if required)
    // --- UNCHANGED ---
    const finalizeLogin = useCallback((accessToken, refreshToken, userData) => {
        try {
            const decodedUser = jwtDecode(accessToken);
            saveTokens(accessToken, refreshToken);
            setMemoryAccessToken(accessToken);
            setAuthState({
                accessToken: accessToken,
                refreshToken: refreshToken,
                isAuthenticated: true,
                user: { ...userData, ...decodedUser },
                isLoading: false,
            });
        } catch (error) {
            console.error("Error finalizing login (decoding token or setting state):", error);
            logout(); // Use logout defined in this context
        }
        // Need to add logout to dependency array if used inside, but it's defined below w/ useCallback
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Logout function
    // --- UNCHANGED ---
    const logout = useCallback(() => {
        removeTokens(); // Clears localStorage and memory token
        setAuthState({
            accessToken: null,
            refreshToken: null,
            isAuthenticated: false,
            user: null,
            isLoading: false, // Finished loading (into logged-out state)
        });
        sessionStorage.removeItem('elliePopupSeen'); // Clear session storage for popup
        // Consider adding navigation trigger if needed globally on logout
        // window.location.href = '/login'; // Avoid if possible, use routing context
    }, []);

    // --- Refresh Token Handling (For interceptor/authFetch) ---
    // --- UNCHANGED ---
    const setRefreshedTokens = useCallback((newAccessToken, newRefreshToken) => {
        try {
            const decodedUser = jwtDecode(newAccessToken);
            saveTokens(newAccessToken, newRefreshToken); // Saves new refresh token to localStorage
            setMemoryAccessToken(newAccessToken);    // Update memory token

            setAuthState(prev => ({
                ...prev,
                accessToken: newAccessToken,
                refreshToken: newRefreshToken,
                isAuthenticated: true, // Definitely authenticated now
                user: {...authState.user, ...decodedUser}, // Update user info from new token
                // isLoading should already be false here
            }));
        } catch (error) {
            console.error("Error setting refreshed tokens:", error);
            logout(); // If setting refreshed tokens fails, log out
        }
    }, [logout]); // Dependency on logout

    // --- Update User Info ---
    // --- UNCHANGED ---
    const setUser = useCallback((user) => {
        setAuthState(prev => ({
            ...prev,
            // Merge carefully: ensure existing user object is spread if partial updates are allowed
            user: prev.user ? { ...prev.user, ...user } : user
        }));
    }, []);


    // --- <<< MODIFIED Initial Load / Persistence Check >>> ---
    // Attempt to initialize state using stored refresh token on component mount
    useEffect(() => {
        const initializeAuth = async () => { // Make async to use await
            const storedRefreshToken = getRefreshToken();

            if (storedRefreshToken) {
                try {
                    // --- Call the refresh token API endpoint ---
                    const { accessToken: newAccessToken, refreshToken: newRefreshToken, user: user } = await callRefreshTokenApi(storedRefreshToken);


                    // --- If refresh is successful, update state ---
                    const decodedUser = jwtDecode(newAccessToken);
                    saveTokens(newAccessToken, newRefreshToken); // Store potentially new refresh token
                    setMemoryAccessToken(newAccessToken);    // Store new access token in memory

                    setAuthState({ // Update entire state
                        accessToken: newAccessToken,
                        refreshToken: newRefreshToken,
                        isAuthenticated: true, // Now authenticated
                        user: { ...user, ...decodedUser }, // Combine UserDto with decoded info if needed
                        isLoading: false, // Finished loading
                    });

                } catch (error) {
                    // --- Refresh failed (token expired, invalid, network error etc.) ---
                    console.warn("AuthContext Init: Silent refresh failed.", error?.message || error);
                    removeTokens(); // Clean up invalid stored token
                    setAuthState({ // Set clean logged-out state
                        accessToken: null,
                        refreshToken: null,
                        isAuthenticated: false,
                        user: null,
                        isLoading: false, // Finished loading (failed)
                    });
                }
            } else {
                // --- No refresh token found ---
                // Ensure initial state reflects logged out if no token, and mark loading done
                setAuthState(prev => ({
                    ...prev,
                    accessToken: null,
                    refreshToken: null,
                    isAuthenticated: false,
                    user: null,
                    isLoading: false // Finished loading
                }));
            }
        };

        initializeAuth();
        // Empty dependency array ensures this runs only once on mount
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Dependencies: finalizeLogin, logout - added based on eslint suggestion if they were used inside, but they aren't directly here now. Keeping empty array.


    // Value provided to consuming components (includes existing setUser)
    // --- UNCHANGED ---
    const value = {
        // State
        isAuthenticated: authState.isAuthenticated,
        user: authState.user, // The decoded user info object
        accessToken: authState.accessToken, // Expose access token if needed directly
        isLoading: authState.isLoading,

        // Actions
        finalizeLogin, // Use this after login + OTP success
        setUser, // Function to update user info in state (kept as requested)
        logout,
        setRefreshedTokens // Function for fetch wrapper / interceptor
    };

    return (
        <AuthContext.Provider value={value}>
            {/* Render children only after initial loading attempt is done */}
            {!authState.isLoading ? children : (
                // Provide a global loading indicator centered in the viewport
                <div style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh", // Full viewport height
                    width: "100vw", // Full viewport width
                    backgroundColor: "#f5f5f5" // Optional background color
                }}>
                    {/* Replace with your preferred loading component */}
                    <CircularProgress size={100} style={{ color: "#247399" }} />
                </div>
            )}
        </AuthContext.Provider>
    );
};